import { defineRouting } from "next-intl/routing"

export const routing = defineRouting({
  locales: ["en", "ar", "de", "es-mx"],
  defaultLocale: "en",
})

export type Locale = (typeof routing.locales)[number]
